"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateManagementHelper = void 0;
class StateManagementHelper {
    static resetFileState() {
        return {
            selectedFile: null,
            parsedData: [],
            validationResult: null,
            dataStatistics: {
                totalSamples: 0,
                averageInputLength: 0,
                averageOutputLength: 0,
                categories: [],
                qualityScore: 0
            }
        };
    }
    static resetPdfState() {
        return {
            selectedPdfFile: null,
            pdfChapters: [],
            showChapterSelection: false,
            pdfContext: '',
            generatedFromPdf: [],
            isPdfLoading: false,
            selectedChapters: new Set()
        };
    }
    static resetManualData() {
        return {
            manualData: [],
            currentEntry: { id: '', input: '', output: '', category: '' },
            isEditingIndex: -1
        };
    }
    static resetFileInput(containerElement) {
        const fileControl = containerElement.querySelector('part-file-upload');
        if (fileControl) {
            fileControl.reset();
        }
    }
    static handleModeSwitch(mode) {
        return {
            shouldResetManual: mode === 'manual',
            shouldResetPdf: mode === 'pdf',
            shouldResetFile: mode === 'file'
        };
    }
    static createEmptyEntry() {
        return { id: '', input: '', output: '', category: '' };
    }
}
exports.StateManagementHelper = StateManagementHelper;
